
// export const logout = ( state ) => {
// }

export const setStates = (state, states) => {
    state.states = states
}

export const setStatesSelectable = (state, states) => {
    state.statesSelectable = states
}

export const setStatesPaginated = (state, statesPaginatedData) => {
    state.statesPaginatedData = statesPaginatedData
}

export const setStateDetail = (state, estate) => {
    state.state = estate
}

export const saveNewStates = (state, estate) => {
    state.states.unshift(estate)
    state.createdData = estate;
}

export const saveUpdatedState = (state, estate) => {
    state.states.unshift(estate)
    state.updatedData = estate;
}

export const setDeleteState = (state, estate) => {
    state.statesPaginatedData.data.filter(x => x.id !== estate.id);
    state.deletedData = estate
}

export const setStateIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setStateIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setStateIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setStateIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
